/* VerdiPot footer grille v1.0.0. Derived from the approved offline vertical demo.
   0.4 is the absolute demo slider value. No network, tracking or storage calls. */
(() => {
  'use strict';
  if (!window.customElements || customElements.get('vp-footer-grille')) return;
  const LOGO_URI = 'data:image/svg+xml;base64,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';
  const S = Object.freeze({ defaultSpeed: 0.4, referencePeriod: 12, light2Rate: .83,
    traceHold: 1, traceFade: 3, maxTraces: 180, maxPixelRatio: 2,
    targetStripes: 470, stripeFill: .41 });
  const clamp = (n, a, b) => Math.min(b, Math.max(a, n));
  const smooth = n => { const t = clamp(n, 0, 1); return t*t*(3-2*t); };
  class FooterGrille extends HTMLElement {
    connectedCallback() {
      if (this._mounted) return;
      this._mounted = true;
      this._events = [];
      this._raf = 0; this._last = null; this._ready = false; this._failed = false;
      this._phase = 0; this._elapsed = 0; this._traces = []; this._paused = false;
      this._width = 0; this._height = 0; this._dpr = 1;
      this._pointer = { active: false, id: null, x: .5, y: .5, lastTime: -1 };
      const v = Number(this.getAttribute('data-speed'));
      this._speed = Number.isFinite(v) && v > 0 ? clamp(v, .1, 4) : S.defaultSpeed;
      this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._reduced = this._motion.matches;
      this._inView = !('IntersectionObserver' in window);
      this._button = this.querySelector('.vp-lg__toggle');
      const listen = (el, name, handler, options) => {
        el.addEventListener(name, handler, options);
        this._events.push(() => el.removeEventListener(name, handler, options));
      };
      try {
        this._visible = ['core','near','far'].map(n => this.querySelector('.vp-lg__'+n));
        this._buffers = Array.from({length: 4}, () => document.createElement('canvas'));
        this._contexts = [...this._visible, ...this._buffers].map(c => c.getContext('2d'));
        if (this._contexts.some(c => !c)) throw new Error('Canvas unavailable');
        [this._core, this._near, this._far, this._lm, this._gm, this._fc, this._rc] = this._contexts;
        [this._logoMask, this._grilleMask, this._field, this._result] = this._buffers;
        this._logo = new Image();
        this._logo.onload = () => {
          if (!this._mounted) return;
          try { this._ready = true; this._resize(); this._update(); this._start(); }
          catch (error) { this._fail(error); }
        };
        this._logo.onerror = () => this._fail(new Error('Embedded logo decode failed'));
        this._logo.src = LOGO_URI;
        if ('ResizeObserver' in window) {
          this._resizeObserver = new ResizeObserver(() => this._safeResize());
          this._resizeObserver.observe(this);
        } else listen(window, 'resize', () => this._safeResize(), {passive:true});
        if ('IntersectionObserver' in window) {
          this._intersection = new IntersectionObserver(entries => {
            this._inView = entries[0].isIntersecting;
            if (this._inView) this._start(); else { this._pointerEnd(); this._stop(); }
          }, {threshold: .01});
          this._intersection.observe(this);
        }
        listen(this, 'pointermove', e => this._pointerMove(e), {passive:true});
        listen(this, 'pointerdown', e => {
          if (e.target.closest('button') || this._reduced || this._paused) return;
          if (this._pointer.id !== null && this._pointer.id !== e.pointerId) return;
          this._pointer.id = e.pointerId;
          try { this.setPointerCapture(e.pointerId); } catch (_) { /* optional */ }
          this._pointerMove(e);
        }, {passive:true});
        for (const name of ['pointerup','pointercancel','lostpointercapture'])
          listen(this, name, e => this._pointerEnd(e), {passive:true});
        listen(this, 'pointerleave', e => {
          if (this._pointer.id === null) this._pointerEnd(e);
        }, {passive:true});
        listen(window, 'pointerup', e => this._pointerEnd(e), {passive:true});
        listen(window, 'blur', () => this._pointerEnd());
        listen(document, 'visibilitychange', () => {
          if (document.hidden) { this._pointerEnd(); this._stop(); }
          else this._start();
        });
        if (this._button) {
          listen(this._button, 'pointermove', () => this._pointerEnd(), {passive:true});
          listen(this._button, 'click', () => {
            if (this._reduced) return;
            this._paused = !this._paused; this._pointerEnd(); this._traces = [];
            this._update(); if (this._paused) this._stop(); else this._start();
          });
        }
        const motionChange = e => {
          this._reduced = e.matches; this._pointerEnd(); this._traces = [];
          this._update(); if (this._reduced) this._stop(); else this._start();
        };
        if (this._motion.addEventListener) listen(this._motion, 'change', motionChange);
        else { this._motion.addListener(motionChange); this._events.push(() => this._motion.removeListener(motionChange)); }
      } catch (error) { this._fail(error); }
    }
    disconnectedCallback() {
      this._mounted = false; this._stop(); this._pointerEnd();
      this._events?.forEach(remove => remove()); this._events = [];
      this._resizeObserver?.disconnect(); this._intersection?.disconnect();
      if (this._logo) this._logo.onload = this._logo.onerror = null;
      this._buffers?.forEach(c => { c.width = c.height = 1; });
      this.removeAttribute('data-animated'); this.removeAttribute('data-ready');
    }
    _fail(error) {
      this._failed = true; this._stop(); this.removeAttribute('data-animated');
      this.removeAttribute('data-ready');
      console.warn('[VerdiPot footer] Static wordmark retained:', error.message);
    }
    _update() {
      this.setAttribute('data-ready', String(this._ready && !this._failed && !this._reduced));
      this.setAttribute('data-animated', String(this._ready && !this._failed && !this._paused && !this._reduced));
      if (this._button) {
        this._button.setAttribute('aria-pressed', String(this._paused));
        const label = this._paused ? 'Resume logo animation' : 'Pause logo animation';
        this._button.setAttribute('aria-label', label); this._button.title = label;
      }
    }
    _canRun() { return this._mounted && this._ready && !this._failed && !this._paused && !this._reduced && this._inView && !document.hidden; }
    _start() {
      if (!this._canRun() || this._raf) return;
      this._last = null; this._raf = requestAnimationFrame(t => this._frame(t));
    }
    _stop() { if (this._raf) cancelAnimationFrame(this._raf); this._raf = 0; this._last = null; }
    _frame(now) {
      this._raf = 0;
      if (!this._canRun()) { this._last = null; return; }
      try {
        const dt = this._last === null ? 0 : clamp((now-this._last)/1000, 0, .08);
        this._last = now; this._advance(dt); this._render();
        this._raf = requestAnimationFrame(t => this._frame(t));
      } catch(error) { this._fail(error); }
    }
    _advance(dt) {
      this._elapsed += dt;
      this._phase += dt*(Math.PI*2/S.referencePeriod)*this._speed;
      this._traces = this._traces.filter(t => this._elapsed-t.born < S.traceHold+S.traceFade);
    }
    _ctx(ctx) { ctx.setTransform(this._dpr,0,0,this._dpr,0,0); }
    _safeResize() { try { this._resize(); } catch(e) { this._fail(e); } }
    _resize() {
      if (!this._ready || this._failed) return;
      const r = this.getBoundingClientRect();
      const w = Math.max(1,r.width), h = Math.max(1,r.height);
      const d = Math.min(window.devicePixelRatio||1,S.maxPixelRatio);
      if (w===this._width && h===this._height && d===this._dpr) return;
      this._width=w; this._height=h; this._dpr=d;
      [...this._visible,...this._buffers].forEach(c=>{c.width=Math.round(w*d);c.height=Math.round(h*d);});
      // Same SVG geometry as the uploaded original, including its original artboard margins.
      // This matches the static inline fallback without enlarging the existing footer section.
      const scale = Math.min(w/147.5,h/46.2);
      this._box = {x:(w-147.5*scale)/2+10.3*scale, y:(h-46.2*scale)/2+9.1*scale,
        w:126.9*scale,h:26.4*scale};
      const b = this._box;
      this._ctx(this._lm); this._lm.clearRect(0,0,w,h);
      this._lm.drawImage(this._logo,b.x,b.y,b.w,b.h);
      this._ctx(this._gm); this._gm.globalCompositeOperation='source-over'; this._gm.clearRect(0,0,w,h);
      this._gm.fillStyle='#fff';
      const pitch=Math.max(1.65,b.w/S.targetStripes),line=Math.max(.60,pitch*S.stripeFill);
      for(let x=b.x;x<b.x+b.w;x+=pitch) this._gm.fillRect(x,b.y,line,b.h);
      this._gm.globalCompositeOperation='destination-in'; this._gm.drawImage(this._logoMask,0,0,w,h);
      this._gm.globalCompositeOperation='source-over'; this._render();
    }
    _lights() {
      const p=this._phase;
      return [
        {x:.5+.385*Math.sin(p-.85),y:.50+.10*Math.sin(p*1.19+.5),rx:.175,ry:.90,strength:.96},
        {x:.5+.380*Math.sin(p*S.light2Rate+2.25),y:.50+.11*Math.cos(p*1.07+1.4),rx:.160,ry:.85,strength:.91}
      ]; // Both strengths are constant: idle lights never fade out.
    }
    _light(x,y,rx,ry,strength) {
      const c=this._fc,b=this._box;
      c.save(); c.translate(b.x+x*b.w,b.y+y*b.h); c.scale(rx*b.w,ry*b.h);
      const g=c.createRadialGradient(0,0,0,0,0,1),v=Math.round(clamp(strength,0,1)*255);
      for(const [stop,m] of [[0,1],[.20,.96],[.51,.60],[.78,.19],[1,0]]) {
        const n=Math.round(v*m);g.addColorStop(stop,`rgb(${n},${n},${n})`);
      }
      c.fillStyle=g;c.fillRect(-1,-1,2,2);c.restore();
    }
    _opacity(age) {return age<=S.traceHold?1:1-smooth((age-S.traceHold)/S.traceFade);}
    _render() {
      if(!this._ready || !this._box) return;
      const w=this._width,h=this._height,c=this._fc,r=this._rc;
      this._ctx(c);c.globalCompositeOperation='source-over';c.fillStyle='#000';c.fillRect(0,0,w,h);
      c.globalCompositeOperation='lighten';
      for(const t of this._lights())this._light(t.x,t.y,t.rx,t.ry,t.strength);
      for(const t of this._traces){const a=this._opacity(this._elapsed-t.born);if(a>0)this._light(t.x,t.y,.115,.72,a*.99);}
      if(this._pointer.active)this._light(this._pointer.x,this._pointer.y,.115,.72,.99);
      c.globalCompositeOperation='source-over';
      this._ctx(r);r.globalCompositeOperation='source-over';r.clearRect(0,0,w,h);
      r.drawImage(this._field,0,0,w,h);r.globalCompositeOperation='destination-in';r.drawImage(this._grilleMask,0,0,w,h);
      r.globalCompositeOperation='source-over';
      for(const o of [this._core,this._near,this._far]){this._ctx(o);o.clearRect(0,0,w,h);o.drawImage(this._result,0,0,w,h);}
    }
    _stamp(x,y) {
      this._traces.push({x,y,born:this._elapsed});
      if(this._traces.length>S.maxTraces)this._traces.splice(0,this._traces.length-S.maxTraces);
    }
    _pointerMove(e) {
      if(!this._canRun() || e.target.closest('button'))return;
      const p=this._pointer;
      if(e.pointerType==='touch' && p.id!==e.pointerId)return;
      if(p.id!==null && p.id!==e.pointerId)return;
      const r=this.getBoundingClientRect(),b=this._box;
      const x=(e.clientX-r.left-b.x)/b.w,y=(e.clientY-r.top-b.y)/b.h;
      if(!Number.isFinite(x)||!Number.isFinite(y))return;
      const dx=x-p.x,dy=(y-p.y)*b.h/b.w,dist=Math.hypot(dx,dy);
      if(p.active&&dist>.012){const count=Math.min(24,Math.ceil(dist/.018));for(let i=1;i<=count;i++)this._stamp(p.x+dx*i/count,p.y+(y-p.y)*i/count);}
      else if(!p.active||this._elapsed-p.lastTime>.06)this._stamp(x,y);
      p.active=true;p.x=x;p.y=y;p.lastTime=this._elapsed;
    }
    _pointerEnd(e) {
      const p=this._pointer;if(!p)return;
      if(e&&p.id!==null&&e.pointerId!==p.id)return;
      if(p.active)this._stamp(p.x,p.y);
      p.active=false;const id=p.id;p.id=null;
      if(id!==null){try{if(this.hasPointerCapture(id))this.releasePointerCapture(id);}catch(_){}}
    }
  }
  customElements.define('vp-footer-grille', FooterGrille);
})();
